import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, OnChanges, SimpleChanges, signal, OnInit, OnDestroy, DoCheck, AfterContentInit, AfterContentChecked, AfterViewInit, AfterViewChecked, inject, computed, Signal } from '@angular/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';

import {
  MatTableModule,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { UsuarioCouchBase } from '../../../model/usuario';
import { AbstractComponent } from '../../../abstract-component';

import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TestHijoAngularComponent } from '../test-hijo-angular/test-hijo-angular.component';
import { HighlightDirective } from '../../../directives/highlight.directive';
import { myclassdecorator } from '../../../decorators/mydecorators';
import { LoggerService } from '../../../services/logger.service';
import { BetterLoggerService } from '../../../services/better-logger.service';
import { PadreService } from '../../../services/padre.service';
import { ActivatedRoute, Data, NavigationEnd, NavigationStart, ResolveFn, Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import {toSignal} from '@angular/core/rxjs-interop';

export const angularResolver: ResolveFn<string> = (route, state) => {
  // Un resolver es un injection point y podrian inyectarse servicios
  const logger = inject(LoggerService);
  
  // Aqui podriamos leer del path.
  const userId = route.queryParamMap.get('id');
  logger.log(`****** Resolviendo dato dinamico desde resolver angularResolver con userId: ${userId}`);
  const retorno= `Mi dato dinamico desde resolver ${userId}`;
  logger.log(`**** retorno: ${retorno}`);
  return retorno;
};

@Component({
  selector: 'app-test-padre-angular',
  imports: [CommonModule, MatFormField, MatLabel, MatTableModule, 
    MatPaginatorModule, MatSortModule, TestHijoAngularComponent, FormsModule, HighlightDirective,ReactiveFormsModule,RouterOutlet,
        RouterLink,
        RouterLinkActive,],
  providers:[{provide: LoggerService, useExisting: BetterLoggerService},
    {provide: PadreService, useValue: {nombre: "padre"}}
  ],
  templateUrl: './test-padre-angular.component.html',
  styleUrl: './test-padre-angular.component.css'
})
@myclassdecorator
export class TestPadreAngularComponent extends AbstractComponent implements OnChanges, OnInit, OnDestroy, DoCheck, AfterContentInit,
AfterContentChecked, AfterViewInit, AfterViewChecked {
  dataSource: MatTableDataSource<UsuarioCouchBase>;
  private datoDelPadreInicial = 100;
  _datoDelPadreInicialSignal = signal(50);
  private activatedRoute = inject(ActivatedRoute)
  private data = toSignal(this.activatedRoute.data, {initialValue: undefined});
  
  
  //computed(() => this.datoDinamico() as string);
  protected datoEstatico: string = this.activatedRoute.snapshot.data['dato_estatico'];
  /*protected datoDinamico = computed(() => {
    const data = this.data();
    if (data && data['usuario']) {
      return data['usuario'] as string;
    }
    return '';
  });*/
  protected datoDinamico = ""
  //private data: Signal<Data | undefined>;
  columnsToDisplay = ["usuario_id", "nombre", "apellidos", "direccion"];
  filaUsuarioSeleccionado?: UsuarioCouchBase;
  indexfilaUsuarioSeleccionado?: number = -1;
  color = "yellow";
  name = new FormControl('');
  ctrlTipoSeleccion = new FormControl("")
  tipoSeleccion="hijo"
  options = [
    { value: "hijo", label: "Hijo"},
    { value: "resolver", label: "Resolver"},
    { value: "signal", label: "Signal"},

  ]
  logger = inject(LoggerService);
  profileForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required, Validators.minLength(3)])
  });
  /*usuarios: Usuario[] = [
            { nombre: 'John', 
              apellidos: 'Doe', 
              direccion: '123 Main St', 
              fx_alta: new Date(), 
              fx_modificacion: new Date(), 
              fx_nacimiento: new Date('1990-01-01'), 
              fx_auto_generada: new Date(), 
              nodo: 'Node1', 
              ip: '127.0.0.1', 
              usuario_id: 1 },
            { nombre: 'Daniel', 
              apellidos: 'Herrero', 
              direccion: 'Madrid', 
              fx_alta: new Date(), 
              fx_modificacion: new Date(), 
              fx_nacimiento: new Date('1990-01-01'), 
              fx_auto_generada: new Date(), 
              nodo: 'Node1', 
              ip: '127.0.0.1', 
              usuario_id: 2 }];
              */
  usuarios: UsuarioCouchBase[] = [];
  @ViewChild(MatTable) table!: MatTable<UsuarioCouchBase>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
     constructor(private router: Router) {
          super()
          this.logger.log("******************** TestPadreAngularComponent constructor");
          //this.LoggerService.log("******************** TestPadreAngularComponent constructor");
          this.dataSource = new MatTableDataSource(this.usuarios);
          // Suscripcion a cambios en control de formulario reactivo
          this.name.statusChanges.subscribe((status)  =>{
            console.log(`Name input status changed: ${status}`);
          });
          this.ctrlTipoSeleccion.valueChanges.subscribe(value =>{
            console.log(value)
            this.tipoSeleccion = value??"hijo";
          });
          this.router.events.subscribe(event => {
            console.log(`Router event: ${event}`);
            if (event instanceof NavigationEnd) {
              console.log(`Recargamos los datos dinamicos: ${event}`);
              const eventNavigationEnd = <NavigationEnd>event;
              console.log("url: ", eventNavigationEnd.url);
              //this.router.navigate(['tests/angular'], { queryParams: { id: eventNavigationEnd.id } });
            } else if (event instanceof NavigationStart) {
              console.log("start navigation: ", event);
            }
            console.log(this.activatedRoute.toString())
            console.log(this.activatedRoute.queryParams.subscribe(params => {
              console.log("Query params: ", params);
              const id = params['id'];
              console.log(`Query param id: ${id}`);
              this.datoDinamico = id;
          }))});
          
        
     }
     reload() {
        console.log("Reloading component");
        //this.router.navigate(['tests/angular'], { queryParams: { id: 222222 } });
        this.router.navigateByUrl('/tests/angular?id=33333',);
     }
  onSubmit(){
    console.log("Form submitted");
    console.log(`First Name: ${this.profileForm.get('firstName')?.value}`);
    console.log(`Last Name: ${this.profileForm.get('lastName')?.value}`);
  }
  ngAfterViewChecked(): void {
    console.log("ngAfterViewChecked");
  }
  ngAfterContentChecked(): void {
    console.log("ngAfterContentChecked");
  }
  ngAfterContentInit(): void {
    console.log("ngAfterContentInit");
  }
  ngDoCheck(): void {
    console.log("ngDoCheck");
  }
  ngOnDestroy(): void {
    console.log("ngOnDestroy");
  }
     clickedRow(arg0: any) {
        console.log(`ClickedRow: ${(<UsuarioCouchBase>arg0).nombre}`);
        const usuario = <UsuarioCouchBase>arg0;
        if (this.tipoSeleccion == "hijo"){
          this.filaUsuarioSeleccionado = arg0;
          console.log("Seleccionado el usurio en el componente hijo")
        } else if (this.tipoSeleccion == "resolver"){
          console.log("Seleccionado el usurio en el componente tio con resolver")
          this.router.navigate(["/tests/angular/detalle_usuario_resolver"], {
            queryParams: {id: usuario.usuario_id}
          })
        } else if (this.tipoSeleccion == "signal"){
          console.log("Seleccionado el usurio en el componente tio con signal")
          this.router.navigate(["tests/angular/detalle_usuario_signal", usuario.usuario_id]);

        }
        
  }
  clickedRowSelected(fila: UsuarioCouchBase):boolean {
    let retorno = false
   
    if (this.filaUsuarioSeleccionado){
      retorno = this.filaUsuarioSeleccionado==fila;
    }
    return retorno;
  }
  async cargarUsuarios(){
    console.log("cargarUsuarios");
    this.usuarios = await this.dhrService.getUsersCouchBase();
    this.dataSource.paginator = this.paginator;
    this.dataSource.data = this.usuarios;
    console.log(`Usuarios cargados: ${this.usuarios.length}`);
  }
  ngOnInit() {
    //this.dataSource.data = this.
    console.log("ngOnInit");
   this.cargarUsuarios();
  }
   ngAfterViewInit(): void {
    //console.log(`ngAfterViewInit ${this.detalle.inputProperty}`);
    console.log("ngAfterViewInit");
    console.log(`**** Aplicando paginador paginador ${this.paginator}`)
    this.dataSource.paginator = this.paginator;
    this.dataSource.paginator.firstPage();
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log("ngonChanges");
    for (const inputName in changes) {
      const inputValues = changes[inputName];
      console.log(`Previous ${inputName} == ${inputValues.previousValue}`);
      console.log(`Current ${inputName} == ${inputValues.currentValue}`);
      console.log(`Is first ${inputName} change == ${inputValues.firstChange}`);
    }
  }
  
  set datoDelPadre(dato: number) {
    //console.log(`set datoDelPadre: ${dato}`);
    this.datoDelPadreInicial = dato;
  }
  get datoDelPadre(): number {
    //console.log(`get datoDelPadre: ${this.datoDelPadreInicial}`);
    return this.datoDelPadreInicial;
  }
  set datoDelPadreInicialSignal(dato: number) {
    //console.log(`set datoDelPadreSignal: ${dato}`);
    this._datoDelPadreInicialSignal.set(dato);
  }
  get datoDelPadreInicialSignal(): number {
    //console.log(`get datoDelPadreSingal: ${this.datoDelPadreInicial}`);
    return this._datoDelPadreInicialSignal()
  } 
}
